const TABS = {
  PROFILE: 'profile',
  LOCATIONS: 'locations',
  DIGITAL_FOOTPRINT: 'digitalFootprint',
  RELATIONS: 'relations',
  OTHERS: 'others',
} as const;

export default TABS;
